<template lang="pug">
shListData(title="Clientes" resolver="customers" keyData="phone" component="shCustomer")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Customers',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/customer/Customers.vue